import React, {useCallback, useState} from 'react';
import {ModelMetadata, modelMetadataUpdateOption} from '../../../../../../store/modelMetadata';
import {useDispatch} from 'react-redux';
import {messageAdd, MessageTypes} from '../../../../../../store/message';
import {useMounted} from '../../../../../../hooks/useMounted';
import UsageList from './UsageList';
import UsageCountTitle from './UsageCountTitle';
import {trackModelMetadataOptionUpdated} from '../../../../../../tracking/tracking';
import {ManageMetadataActionProps} from '../ActionMenuTypes';
import UpdateOptionForm from './UpdateOptionForm';
import {CloseOutlined} from '@ant-design/icons';
import styles from './UpdateOption.module.scss';

const UpdateOption: React.FC<ManageMetadataActionProps> = ({
  property,
  value,
  onSuccess,
  onCancel,
  refreshOptionsCount,
  fileTagCount,
}) => {
  const dispatch = useDispatch();

  const [submitting, setSubmitting] = useState(false);
  const mounted = useMounted();

  const handleSubmit = useCallback(
    (newValue: string, metadata?: ModelMetadata) => {
      setSubmitting(true);
      return modelMetadataUpdateOption(dispatch, property, value, newValue, metadata)
        .then(() => {
          dispatch(messageAdd(`The option has been updated`, MessageTypes.SUCCESS));
          trackModelMetadataOptionUpdated();
          onSuccess(newValue);
          if (refreshOptionsCount) refreshOptionsCount();
        })
        .catch(() => null)
        .finally(() => {
          mounted.current && setSubmitting(false);
        });
    },
    [dispatch, onSuccess, property, value, mounted, refreshOptionsCount],
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <h2 className={styles.title}>Edit Option</h2>
        </div>
        <button className={styles.closeBtn} onClick={onCancel} aria-label="Close">
          <CloseOutlined />
        </button>
      </div>
      <div className={styles.formWrapper}>
        <p className={styles.subtitle}>
          <UsageCountTitle property={property} value={value} fileTagCount={fileTagCount} />
        </p>

        <UpdateOptionForm
          property={property}
          onSubmit={handleSubmit}
          onCancel={onCancel}
          value={value}
          submitting={submitting}
        />

        <UsageList property={property} value={value} fileTagCount={fileTagCount} />
      </div>
    </div>
  );
};

export default UpdateOption;
